module.exports = __webpack_public_path__ + "img/you@2x.491e2102.png";